import { Styles } from '@monkvision/types';
import { DynamicSVGProps } from '@monkvision/common-ui-web';
import { CSSProperties, useCallback } from 'react';
import { fullyColorSVG, useMonkTheme, useResponsiveStyle } from '@monkvision/common';
import { VideoCapturePageLayoutProps } from './VideoCapturePageLayout.types';
import { PAGE_LAYOUT_MAX_HEIGHT_BREAKPOINT } from './PageLayoutItem/PageLayoutItem.styles';

export const styles: Styles = {
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  containerBackdrop: {
    backgroundColor: 'rgba(0, 0, 0)',
  },
  logo: {
    margin: '32px 0',
    width: 80,
    height: 'auto',
  },
  logoSmall: {
    __media: {
      maxHeight: PAGE_LAYOUT_MAX_HEIGHT_BREAKPOINT,
    },
    display: 'none',
  },
  title: {
    fontSize: 32,
    fontWeight: 700,
    textAlign: 'center',
    padding: '0 32px 16px 32px',
  },
  titleSmall: {
    __media: {
      maxHeight: PAGE_LAYOUT_MAX_HEIGHT_BREAKPOINT,
    },
    fontSize: 20,
    fontWeight: 700,
    textAlign: 'center',
    padding: '10px 16px 10px 16px',
  },
  childrenContainer: {
    flex: 1,
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  confirmContainer: {
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 32px 32px 32px',
  },
  confirmButton: {
    alignSelf: 'stretch',
    maxWidth: 400,
  },
};

interface VideoCapturePageLayoutStyles {
  logoProps: Partial<DynamicSVGProps>;
  containerStyle: CSSProperties;
  titleStyle: CSSProperties;
}

export function useVideoCapturePageLayoutStyles({
  showBackdrop,
}: Required<Pick<VideoCapturePageLayoutProps, 'showBackdrop'>>): VideoCapturePageLayoutStyles {
  const { palette } = useMonkTheme();
  const { responsive } = useResponsiveStyle();

  const getLogoAttributes = useCallback(
    (element: Element) => fullyColorSVG(element, palette.text.primary),
    [palette],
  );

  return {
    logoProps: {
      getAttributes: getLogoAttributes,
      style: {
        ...styles['logo'],
        ...responsive(styles['logoSmall']),
      },
    },
    containerStyle: {
      ...styles['container'],
      ...(showBackdrop && { backgroundColor: palette.background.base }),
    },
    titleStyle: {
      ...styles['title'],
      ...responsive(styles['titleSmall']),
    },
  };
}
